


export default function About()
{
    return (
        <div className='Page'>
            <h1>A propos</h1>

            <p>
            Le Philips VG5000μ, lancé le 1er octobre 1984, est un micro-ordinateur 8 bits conçu par Philips et fabriqué par Radiotechnique (RTS) au Mans, en France.<br/>
            Commercialisé sous les marques Philips, Radiola et Schneider, il visait principalement le marché français, notamment pour un usage éducatif et domestique.<br/>
            Avec un prix initial d'environ 1 500 à 1 990 FF, il se positionnait comme une machine d'initiation à l'informatique, comparable au ZX-81 ou au Matra Alice.
            </p>

            <h2>
            Caractéristiques techniques principales :
            </h2>

            <p>
                <ul>
                    <li>Processeur : Zilog Z80A à 4 MHz.</li>
                    <li>Mémoire : 24 Ko de RAM (dont 8 Ko pour l'affichage, extensible à 56 Ko) et 18 Ko de ROM incluant le VG5000 BASIC (dérivé du Microsoft BASIC-80).</li>
                    <li>Affichage : Semigraphique, équivalent à 320 x 250 pixels en 8 couleurs, basé sur des caractères 8x10 pixels (processeur vidéo SGS Thomson EF9345).</li>
                    <li>Son : 1 voie sur 5 octaves. Mais pas de processeur dédié.</li>
                    <li>Clavier : AZERTY de 63 touches, inspiré du Minitel, avec des raccourcis pour les commandes BASIC.</li>
                    <li>Connectivité : Ports pour cassette (1200/2400 bauds), Péritel, et bus d’extension.</li>
                    <li>Périphériques : Lecteur de cassettes, extensions mémoire (16 Ko, mais il a pu exister plus bien que je n'en trouve trace), joysticks, et imprimantes (40/80 colonnes).</li>
                </ul>
            </p>

            <h2>
                Historique et contexte :
            </h2>

            <p>
                Le VG5000 fut dévoilé lors du Salon du Son et de l'Image à Paris en 1984, sous forme d'une maquette en bois, avant sa sortie officielle en fin d'année.<br/>
                Philips, déjà connu pour ses consoles Videopac, a adopté une stratégie similaire en distribuant le VG5000 sous trois marques pour donner une impression de standardisation, comme pour le MSX.<br/>
                Cependant, il n'était pas compatible avec ce standard ni avec d'autres ordinateurs, ce qui limita son attrait.
            </p>
            <p>
                Destiné principalement aux écoles et aux débutants, il s'appuyait sur des composants recyclés, comme le clavier et le générateur de caractères du Minitel, fabriqué par RTS.<br/>
                Malgré une bibliothèque d'environ 40 jeux (dont La Moto Infernale, Citadelle, ou US Rallye) et des logiciels éducatifs, la qualité des jeux était souvent médiocre, 
                et la machine souffrait de limitations techniques, notamment son affichage texte en 40x25 caractères.
            </p>

            <h2>
                Réception et fin :
            </h2>

            <p>
                Le VG5000 connut un succès relatif avec 35 000 unités vendues en deux mois et demi en 1984, et environ 300 000 unités écoulées cette année-là selon un rapport interne de Philips.<br/>
                Cependant, face à une concurrence plus performante (Amstrad CPC, Commodore 64, ZX Spectrum), il fut considéré comme peu puissant et peu innovant.<br/>
                La production cessa en 1986, marquant un échec commercial à long terme.
            </p>
        </div>
    )
}